import React, { Component } from 'react'
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import $ from 'jquery'

import {
    setRegPage, setLoadingMass,
    validateGuestdetail, popupOpenClose,
    setDeviceLoginPage, currentWidget
} from '../../action/action'
import { guestDdeviceRegColorset } from '../../JS/setColors'
import { defultIP } from '../../config/constant'
import { setWebViewAfterKeyBoard } from '../../JS/setWebView'
import { clearDoorKey, wipeGuestData } from '../../JS/wipeGuestData'
import { fetchSessionToken } from '../../JS/fetchSessionToken'
import { getDefaultAnalyticsLabel } from '../../layout2.0/JS/utility';
import { sendAnalytics } from '../../action/homeAction';

class GuestDeviceReg extends Component {
    constructor(props) {
        super(props);
        this.state = {
            roomNo: "",
            GuestName: null,
            status: false,
            error: false,
            errorMsg: null,
            deviceError: false,
            deviceErrorMsg: null,
            submitClick: true
        }
    }

    handleSubmit = (event) => {
        console.log("on submit", event);
        //alert("on submit");
        // let SessionToken = localStorage.getItem("GuestJourneySessionToken");
        let encodedData = fetchSessionToken();
        let srcElement;
        event.preventDefault();
        if (this.state.error) {
            this.setState({ error: false });
        }
        event.srcElement ? srcElement = event.srcElement
            : srcElement = { deviceName: {}, IPAddress: {} }
        let guestName = //event.target.guestName.value || srcElement.guestName.value || 
            document.getElementById("InputForguestName").value;
        let roomNumber = //event.target.roomNo.value || srcElement.roomNo.value || 
            document.getElementById("InputForroomNo").value;
        if (guestName && roomNumber) {
            this.props.validateGuestdetail(encodedData, guestName, roomNumber, this.callBackFunc);
            this.props.setLoadingMass(true);

        } else {
            console.log("complete session flow first");
            this.props.popupOpenClose(true, "Oops Something went wrong, Please try after some time.");
        }
    }
    componentDidMount() {
        guestDdeviceRegColorset(this.props.menuColor);
        this.props.currentWidget({});

        $('#guestDevRegNext').on("touchstart", (event) => {
            console.log("guestDevRegNext touch");
            if (this.state.submitClick) {
                
                document.getElementById('guestDevRegNext').click();
            }
        })
    }
    callBackFunc = async (status, room, guestToken) => {
        let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})
        if (status) {
            this.props.sendAnalytics(
                this.props.guestDetail,
                "LINK_TO_ROOM",
                "link to room - success",
                { ...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget" },
                0,
                (room && room != "null") ? room : false
            );
            //wipeGuestData();
            let rervationNO = localStorage.getItem("reservationNo");
            this.props.setLoadingMass(false);
            this.props.setRegPage(false);
            localStorage.setItem("room", room);
            localStorage.setItem("guestToken", guestToken);
            //localStorage.setItem("ConnectorIP", defultIP);
            if (rervationNO && rervationNO !== "null") {
                localStorage.setItem("reservationNo", "");
                await clearDoorKey();
            }
            if (this.props.guestLoginPage) {
                this.props.setDeviceLoginPage(false);
            }
            document.location.reload();
        } else {
              this.props.sendAnalytics(
                this.props.guestDetail,
                "LINK_TO_ROOM",
                "link to room - failed",
                { ...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget" },
                0,
                (room && room != "null") ? room : false
            );
            this.props.setLoadingMass(false);
            if (this.props.guestLoginPage) {
                this.setState({ error: true, errorMsg: "We cannot find that  Name/Room combination, please contact the Front Desk." });
            } else {
                this.props.popupOpenClose(true, "We cannot find that  Name/Room combination, please contact the Front Desk.");
            }
        }
    }
    onNoClick = () => {
        this.props.setRegPage(false);
        if (this.props.guestLoginPage) {
            this.props.setDeviceLoginPage(false);
            //console.log("location", window.history);
            if (this.props.currentWidget && this.props.currentWidget.widgetType) {
                window.history.back();
            } else {
                document.location.reload();
            }

            //window.location.replace();
        } else {
            document.location.reload();
        }
    }
    handleCHange = (event, field) => {
        let len = event.target.value.length;
        let str = event.target.value.charAt(len - 1);
        // TODO: Remove RegExp for guestname 
        let dReg = field === "roomNo" ? new RegExp('^[a-zA-Z0-9 ]+$') : new RegExp('^[a-zA-Z ]+$');
        if (str.match(dReg) || str === "-" || str === "_" || len === 0) {
            if (field === "roomNo") {
                this.setState({ roomNo: event.target.value, error: false });
            } else {
                this.setState({ GuestName: event.target.value, error: false });
            }
        } else {
            if (field === "roomNo") {
                this.setState({
                    roomNo: event.target.value.substring(0, len - 1),
                    error: true, errorMsg: `${str} is invalid input character.`
                });
            } else {
                // Milind: Commenting because numbers are allowed.
                // this.setState({
                //     GuestName: event.target.value.substring(0, len - 1),
                //     error: true, errorMsg: `${str} is invalid input character.`
                // });
            }
        }
        if (field === "roomNo") {
            this.setState({ roomNo: event.target.value });
        } else {
            this.setState({ GuestName: event.target.value });
        }
    }

    blurWithSubmit = (event) => {
        console.log("blurWithSubmit", event.relatedTarget);
        if (event && event.relatedTarget && event.relatedTarget.id === 'guestDevRegNext') {
            if (this.state.submitClick) {
                this.setState({ submitClick: false })
                this.handleSubmit(event)
            }
        }
        event.preventDefault();
        document.body.scrollTop = 0;
        window.scrollTo(0, 0);
    }

    submitKeyEvent = (event) => {
        if (event.keyCode === 13) {
            console.log("keycode", event.keyCode);
            //document.getElementById("guestDevRegNext").click();
            if (this.state.submitClick) {
                this.setState({ submitClick: false })
                this.handleSubmit(event);
            }
            event.preventDefault();
        }
    }

    submitAfterBlur = (event) => {
        event.preventDefault();
        if (this.state.submitClick) {
            this.setState({ submitClick: false })
            this.handleSubmit(event);
        }
    }

    render() {
        return (
            <section id="app-body" className="col">
                <div id="ico-devReg" className="contentSection overUnder columns h-100 center-v">
                    <div id="guestDevReg" className="col" style={{
                        background: "rgba(255,255,255,0.95)", marginRight: 0,
                        padding: "1rem", maxWidth: "30rem",
                        margin: "0 auto", height: "auto"
                    }}>
                        <div id="connectorReg" className="form">
                            <form
                                id="submitGuestLogin"
                                style={{ color: "inherit" }}>
                                <div className="form-item" style={{ color: "inherit" }}>
                                    <label for="client-name" style={{ color: "inherit" }}>Last Name:</label>
                                    <input
                                        id="InputForguestName"
                                        type="input"
                                        name="guestName"
                                        placeholder=""
                                        minlength="3"
                                        maxlength="50"
                                        onChange={(event) => { this.handleCHange(event, "guestName") }}
                                        value={this.state.deviceName}
                                        style={{ width: "100%", color: "inherit" }}
                                        onBlur={(event) => { setWebViewAfterKeyBoard(event) }}
                                        required />
                                </div>
                                <div style={{ paddingLeft: "1rem" }}>
                                    {
                                        this.state.deviceError ?
                                            this.state.deviceErrorMsg : null
                                    }
                                </div>
                                <div className="form-item" style={{ color: "inherit" }}>
                                    <label for="client-comment" style={{ color: "inherit" }}>Room No:</label>
                                    <input
                                        id="InputForroomNo"
                                        type="input"
                                        name="roomNo"
                                        value={this.state.roomNo}
                                        placeholder=""
                                        minlength="2"
                                        maxlength="15"
                                        onKeyDown={this.submitKeyEvent}
                                        style={{ width: "100%", color: "inherit" }}
                                        onChange={(event) => { this.handleCHange(event, "roomNo") }}
                                        onBlur={(event) => { this.blurWithSubmit(event) }}
                                        required />
                                </div>
                                <div style={{ paddingLeft: "1rem", color: "red", fontWeight: "bold" }}>
                                    {
                                        this.state.error ?
                                            this.state.errorMsg : null
                                    }
                                </div>
                                <div className="form-controls">
                                    <button
                                        onClick={this.submitAfterBlur}
                                        type="submit" id="guestDevRegNext" className="primary">Connect</button>
                                    <button className="secondary" onClick={this.onNoClick}>Cancel</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

const mapStateToProps = state => {
    return {
        menuColor: state.store.home.MenuColor,
        guestLoginPage: state.store.guestLoginPage,
        currentWidget: state.store.sideNavBar.currentWidget,
        currentHomePage: state.store2.currentHomePage,
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        guestDetail: state.store.home.guestDetails,
    }
}
export default connect(
    mapStateToProps,
    {
        setRegPage,
        setLoadingMass,
        validateGuestdetail,
        popupOpenClose,
        setDeviceLoginPage,
        currentWidget,
        sendAnalytics
    }
)(GuestDeviceReg);